function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.2 0C17.4032 0 20 2.59675 20 5.8L20 14.2C20 17.4033 17.4032 20 14.2 20L5.8 20C2.59675 20 0 17.4033 0 14.2L0 5.8C0 2.59675 2.59675 0 5.8 0L14.2 0ZM2 5.59998L2 14.4C2 16.3882 3.61177 18 5.6 18L14.4 18C16.3882 18 18 16.3882 18 14.4L18 5.59998C18 3.61176 16.3882 1.99998 14.4 1.99998L5.6 1.99998C3.61177 1.99998 2 3.61176 2 5.59998ZM16.5 4.74998C16.5 5.44034 15.9404 5.99998 15.25 5.99998C14.5596 5.99998 14 5.44034 14 4.74998C14 4.05963 14.5596 3.49998 15.25 3.49998C15.9404 3.49998 16.5 4.05963 16.5 4.74998ZM15 9.99998C15 12.7614 12.7614 15 10 15C7.23857 15 5 12.7614 5 9.99998C5 7.23856 7.23857 4.99998 10 4.99998C12.7614 4.99998 15 7.23856 15 9.99998ZM7 9.99998C7 11.6569 8.3431 13 10 13C11.6569 13 13 11.6569 13 9.99998C13 8.34318 11.6569 6.99998 10 6.99998C8.3431 6.99998 7 8.34318 7 9.99998Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
});

var SvgInstagramWhite = function SvgInstagramWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstagramWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instagram_white.ea305328.svg";
export { ForwardRef as ReactComponent };